import "./FloatingWindow.css";
import { defineComponent as r, useCssVars as i, unref as e, openBlock as s, createElementBlock as a, normalizeClass as l, renderSlot as _ } from "vue";
import { u as c } from "./useTheme-c099edf3.js";
import { _ as p } from "./_plugin-vue_export-helper-dad06003.js";
const m = /* @__PURE__ */ r({
  __name: "FloatingWindow",
  props: {
    mode: { default: "window" },
    position: { default: "bottom" }
  },
  setup(d) {
    i((n) => ({
      "7c3c9b64": e(o).borderRadius,
      "0db64227": e(o).borderColor
    }));
    const t = d, o = c();
    return (n, f) => (s(), a("div", {
      class: l([
        "floating-window",
        `floating-window--${t.mode}`,
        `floating-window--${t.position}`,
        { "floating-window--bordered": e(o).border }
      ])
    }, [
      _(n.$slots, "default", {}, void 0, !0)
    ], 2));
  }
});
const v = /* @__PURE__ */ p(m, [["__scopeId", "data-v-144006d4"]]);
export {
  v as default
};
//# sourceMappingURL=FloatingWindow.js.map
